import { usePageProps } from "common/hooks/data/usePageProps"
import type { AppProps } from "common/lib/getAppServerSideProps"

export const useRegionCode = () => {
  const { regionCode } = usePageProps<AppProps>()

  return regionCode
}
